<div id="eventCreationDialog" class="modal modal-lg modal-dialog fade in" role="dialog" style="display: none;" appDraggable dragTarget="#eventCreationDialog" dragHandle="#eventCreationDialogHeader">
	<div class="modal-content" *ngIf="event != null">
		<div class="modal-header" id="eventCreationDialogHeader">
			<button type="button" class="close" (click)="hide()"><i class="fa fa-times" aria-hidden="true"></i></button>

			<h4 class="modal-title">
				<i class="fa fa-refresh" aria-hidden="true"></i> GENERATE TRIGGER: {{event.name}}
			</h4>
		</div>
	
		<div class="modal-body internal-well" *ngIf="eventInstance != null">
<!-- 			<ng-container *ngFor="let datum of eventInstance.data"> -->
<!-- 				<div class="form-group"> -->
<!-- 					<div class="col-sm-4"><label>{{datum.property.name}}</label></div> -->
<!-- 					<div class="col-sm-8" [ngSwitch]="true"> -->
<!-- 						<app-entity-field [datum]="datum" *ngSwitchCase="datum.property.type == propertyType.ZONE_REFERENCE || -->
<!-- 																		 datum.property.type == propertyType.TAG_REFERENCE || -->
<!-- 																		 datum.property.type == propertyType.OBJECT_REFERENCE || -->
<!-- 																		 datum.property.type == propertyType.LOCATION_REFERENCE || -->
<!-- 																		 datum.property.type == propertyType.USER_REFERENCE"> -->
<!-- 						</app-entity-field> -->
<!-- 						<input class="form-control" type="text" [(ngModel)]="datum.value" *ngSwitchDefault/> -->
<!-- 					</div> -->
<!-- 				</div> -->
<!-- 			</ng-container> -->

				<div style="display: flex; flex-direction: row; flex-wrap: wrap">			
			<ng-container *ngFor="let datum of eventInstance.data">

					<label style="">{{datum.property.name}}</label>
					<input style="" class="form-control" type="text" [(ngModel)]="datum.value" />

			</ng-container>
							</div>
		</div>

		<div class="modal-footer">
			<button type="button" class="btn btn-default" (click)="hide()"><i class="fa fa-ban" aria-hidden="true"></i> CANCEL</button>
			<button button class="btn btn-primary" (click)="onGenerate()"><i class="fa fa-bolt" aria-hidden="true"></i> GENERATE </button>
		</div>
	</div>
</div>